import { Dropdown, Tag, type MenuProps } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { useProjectContext } from '../auth/ProjectContext';

/** Header project chip — same look as LocationPicker. Shown only when the box
 *  manages projects. Unlike locations it stays visible with a single entry, so
 *  the user always sees they're working in "ללא פרויקט". */
export function ProjectPicker() {
  const { projects, selectedProjectId, setSelectedProjectId, selectedProject, manageProjects } =
    useProjectContext();

  if (!manageProjects || projects.length === 0) return null;

  const items: MenuProps['items'] = projects.map((p) => ({
    key: String(p.id),
    label: p.name,
  }));

  const onClick: MenuProps['onClick'] = (info) => {
    setSelectedProjectId(Number(info.key));
  };

  return (
    <Dropdown
      menu={{ items, onClick, selectedKeys: [String(selectedProjectId ?? '')] }}
      trigger={['click']}
    >
      <Tag
        style={{
          backgroundColor: '#ffffff',
          cursor: 'pointer',
          color: '#3b3b3b',
          borderColor: '#ffffff',
          paddingBlock: 4.8,
          paddingInline: 9.6,
          fontSize: 16,
          display: 'flex',
          alignItems: 'center',
          columnGap: 5,
          height: 38,
          marginInlineEnd: 0,
        }}
      >
        <span dir="auto">{selectedProject?.name ?? 'בחר פרויקט'}</span>
        <FontAwesomeIcon icon={faAngleDown} style={{ color: '#3B3B3B' }} />
      </Tag>
    </Dropdown>
  );
}
